<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
    <button mat-flat-button color="accent" [routerLink]="['create']">
      <mat-icon>add_user</mat-icon>
      Crear acta de reunión
    </button>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>
      <mat-form-field>
        <input matInput type="text" formControlName="search" />
        <button matSuffix mat-icon-button aria-label="Clear">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Concepto</th>
          <td mat-cell *matCellDef="let meeting">
            <span>{{ meeting.title }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let meeting">
            <span>{{ meeting.date | date: 'short' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="assistants">
          <th mat-header-cell *matHeaderCellDef>Asistentes</th>
          <td mat-cell *matCellDef="let meeting">
            @let assistantsPreview = meeting.users | usersPreview: assistantsPreviewVisibleCount;
            <span class="users-preview-cell">
              @if (assistantsPreview.line) {
                <span class="users-preview-cell__line">{{ assistantsPreview.line }}</span>
              }
              @if (assistantsPreview.extraCount !== null) {
                <span class="users-preview-cell__extra">+{{ assistantsPreview.extraCount }}</span>
              }
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let meeting; let i = index">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item [routerLink]="[meeting.id]">
                <mat-icon matPrefix>edit</mat-icon>
                Editar acta
              </button>
              <button mat-menu-item (click)="deleteMeetingRecord(meeting.id)">
                <mat-icon matPrefix>delete</mat-icon>
                Borrar acta
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
